import { render } from "./PostcodeField.vue?vue&type=template&id=1ea9275c"
import script from "./PostcodeField.vue?vue&type=script&lang=js"
export * from "./PostcodeField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__